module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "mobile-navbar"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "router-link mobile-navbar-option",
    attrs: {
      "to": "/vacaciones"
    }
  }, [_c('i', {
    staticClass: "fa fa-plane"
  }), _c('span', [_vm._v("Mis vacaciones")])])], 1), _c('li', [_c('router-link', {
    staticClass: "router-link mobile-navbar-option",
    attrs: {
      "to": "/permisos"
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _c('span', [_vm._v("Mis permisos")])])], 1), _c('li', [_c('router-link', {
    staticClass: "router-link mobile-navbar-option",
    attrs: {
      "to": "/boletas"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _c('span', [_vm._v("Mis boletas")])])], 1), _c('li', {
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-navbar-option"
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _c('span', [_vm._v("Opciones")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8cd3ab4","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Bottom_Bar.vue
// module id = 862
// module chunks = 0